/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveCabinetIcon64Regular = forwardRef('ArchiveCabinetIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M23 20.5a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 0 3h-15a1.5 1.5 0 0 1-1.5-1.5Z" }),
        React.createElement("path", { d: "M24.5 43a1.5 1.5 0 0 0 0 3h15a1.5 1.5 0 0 0 0-3h-15Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.5 6C15.701 6 11 10.701 11 16.5v31C11 53.299 15.701 58 21.5 58h21C48.299 58 53 53.299 53 47.5v-31C53 10.701 48.299 6 42.5 6h-21ZM50 31V16.5A7.5 7.5 0 0 0 42.5 9h-21a7.5 7.5 0 0 0-7.5 7.5V31h36Zm-36 3h36v13.5a7.5 7.5 0 0 1-7.5 7.5h-21a7.5 7.5 0 0 1-7.5-7.5V34Z" })));
});
